import React from "react"

export const ArticleTags = ({
  ressort,
  is_comment,
  is_exclusive,
  advertorial,
}) => {
  return (
    <div className="level is-mobile">
      <div className="level-left">
        {advertorial.is_advertorial > 0 && (
          <div className="level-item">
            <span className={`tag is-grey`}>Anzeige</span>
          </div>
        )}
        {!!is_comment ? (
          <div className="level-item">
            <span className={`tag is-${ressort}`}>Kommentar</span>
          </div>
        ) : null}
        {!!is_exclusive ? (
          <div className="level-item">
            <span className={`tag is-${ressort}`}>Exklusiv</span>
          </div>
        ) : null}
      </div>
    </div>
  )
}
